import React, { Component } from "react";

class EmailComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { handleEmailChange, handleSendOTP, email, emailError, styles } =
      this.props;

      return (
      <div className={styles.email_otp}>
        <div className={styles.email_otp__background}>
          <div className={styles.email_otp__content}>
            {/* Hero Section */}
            <div className={styles.email_otp__hero}>
              <div className={styles.email_otp__icon}>
                <div className={styles.email_otp__icon}>
                  <img src="/images/user-account.svg" alt="user" />
                </div>
              </div>
              <h1 className={styles.email_otp__title}>
                Stay connected to your journeys
              </h1>
              <p className={styles.email_otp__subtitle}>
                Track your bookings, sync across devices, save must-do
                experiences, and speed up your checkout.
              </p>
            </div>

            {/* Form Section */}
            <div className={styles.email_otp__form_container}>
              <h2 className={styles.email_otp__form_title}>
                Continue with Email
              </h2>
              <p className={styles.email_otp__form_subtitle}>
                Hang tight! We're sending an OTP code to your email for
                verification.
              </p>

              <form
                className={styles.email_otp__form}
                onSubmit={(e) => e.preventDefault()}
              >
                <div className={styles.email_otp__field}>
                  <label
                    className={styles.email_otp__label}
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <div className={styles.email_otp__input_container}>
                    <input
                      className={`${styles.email_otp__input} ${emailError ? styles.email_otp__input_error : ""
                        }`}
                      type="email"
                      id="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="you@example.com"
                      aria-describedby={emailError ? "email-error" : undefined}
                    />
                    {emailError && (
                      <div
                        className={styles.email_otp__error}
                        id="email-error"
                      >
                        {emailError}
                      </div>
                    )}
                  </div>
                </div>

                <div className={styles.email_otp__submit_container}>
                  <button
                    className={`${styles.email_otp__submit_btn} ${!email ? styles.email_otp__submit_btn_disabled : ""
                      }`}
                    type="button"
                    onClick={handleSendOTP}
                    disabled={!email}
                  >
                    Send OTP
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailComponent;
